var React = require('react');

function HamburgerMenu (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"16","height":"3","rx":"1.5","fill":"#919DAF","key":0}),React.createElement("rect",{"y":"6","width":"24","height":"3","rx":"1.5","fill":"#919DAF","key":1}),React.createElement("rect",{"y":"12","width":"20","height":"3","rx":"1.5","fill":"#919DAF","key":2})]);
}

HamburgerMenu.defaultProps = {"width":"24","height":"15","viewBox":"0 0 24 15","fill":"none"};

module.exports = HamburgerMenu;

HamburgerMenu.default = HamburgerMenu;
